module.exports = __webpack_public_path__ + "static/media/claudia.bb3d10e4.jpg";